import React, { useState, useEffect } from "react";
import styles from "./styles";
import { connect } from "react-redux";
import * as actionsAdjuntos from "../../../../actions/adjuntarArchivo";
import * as actionsPresentacion from "../../../../actions/nuevaPresentacion";
import * as actionsVentanaDialogo from "../../../../actions/ventanaDialogo";
import * as actionsSnackMensaje from "../../../../actions/snackMensaje";
import UploadServices from "../../../../services/upload-files";
import {
    Container,
    Typography,
    Tooltip,
    Button,
    Input,
} from "@material-ui/core";
import uploadIcono from "../../../../assets/iconos/upload-icon.png";
import excelFile from "../../../../assets/iconos/excel-disable.png";
import ArchivosSubidos from "../../ArchivosSubidos/ArchivosSubidos";

const Prestaciones = (props) => {
    const classes = styles();
    const extensionesAceptadas = ".xls,.xlsx,.txt";
    const [textoLabel, setTextoLabel] = useState("Aceptar");

    const filtrarArchivosPorExtension = (archivos) => {
        const archivosFiltrados = archivos.filter((archivo) => {
            const extensiones = extensionesAceptadas.split(",");
            let arcValido = false;

            for (let i = 0; i < extensiones.length; i++) {
                const extension = extensiones[i];

                if (archivo.name.toLowerCase().endsWith(extension)) {
                    arcValido = true;
                    break;
                }
            }

            return arcValido;
        });

        return archivosFiltrados;
    };

    const descargarPlanilla = () => {
        UploadServices.descargarTemplate();
    };

    const actualizarLabelModal = (archivo) => {
        const fragmentos = archivo.name.split(".");
        const index = fragmentos.length - 1;
        const extension = fragmentos[index];

        if (extension.toLowerCase() === "txt") {
            setTextoLabel("Cerrar");
        } else {
            setTextoLabel("Aceptar");
        }
    };

    const propcesarSubidaArchivos = (archivos) => {
        const fullPath = "presentaciones/file/prestaciones";
        const archivosFiltrados = filtrarArchivosPorExtension([...archivos]);
        actualizarLabelModal(archivos[0]);

        if (archivosFiltrados.length > 0) {
            props.archivosSeleccionados(
                archivosFiltrados,
                fullPath,
                props.actualizarPrestacionesFiles,
                props.prestaciones,
                props.pathTemporal
            );
        } else {
            const mensaje =
                "No se procesó ninguno de los archivos seleccionados, ya que no cumplen con las extensiones soportadas [*.xls,*.xlsx,*.txt]";

            const ventanaConfig = {
                estaVisible: true,
                titulo: "Error al procesar archivos",
                mensaje: mensaje,
                esAlerta: true,
                clickAceptar: () =>
                    props.actualizarAtriutoVentanaDialogo({
                        estaVisible: false,
                    }),
            };
            props.actualizarAtriutoVentanaDialogo(ventanaConfig);
        }

        document.getElementById("inputPrestaciones").value = null;
    };

    const mostrarBtnDescargar = () => {
        if (props.soloVista) {
            return null;
        }

        return (
            <Button className={classes.btnAdjuntar} onClick={descargarPlanilla}>
                <img
                    src={excelFile}
                    alt="Subir archivo"
                    className={classes.iconoExcel}
                />
                Descargar planilla
            </Button>
        );
    };

    const mostrarBtnImportar = () => {
        const existeArchivo =
            props.prestaciones.length > 0 &&
            !props.prestaciones[props.prestaciones.length - 1].bajaLogica;

        if (props.soloVista || existeArchivo) {
            return null;
        }

        return (
            <Button
                variant="outlined"
                component="label"
                className={classes.btnAdjuntar}
            >
                <Input
                    id="inputPrestaciones"
                    type="file"
                    onChange={(event) =>
                        propcesarSubidaArchivos(event.target.files, props.index)
                    }
                    inputProps={{
                        accept: extensionesAceptadas,
                        hidden: true,
                    }}
                />
                <img
                    src={uploadIcono}
                    alt="Subir archivo"
                    className={classes.iconoUpload}
                />
                Importar prestaciones
            </Button>
        );
    };

    const construirMensajeModal = () => {
        let mensaje = [];

        for (let i = 0; i < props.erroresArchivos.length; i++) {
            const error = props.erroresArchivos[i].defaultMessage;
            mensaje.push(<p key={i}>{error}</p>);
        }

        return mensaje;
    };

    const onClickModalButton = () => {
        props.actualizarAtriutoArchivos({ erroresArchivos: [] });
    };

    const buscarArchivo = (index, arreglo) => {
        const output = {
            archivo: null,
            index: null,
        };
        let indexBuscado = index;
        let i = 0;
        while (i < arreglo.length) {
            const elemento = arreglo[i];

            if (
                elemento.bajaLogica ||
                elemento.nombreArchivo.includes("_original.")
            ) {
                indexBuscado++;
            } else if (indexBuscado === i) {
                output.archivo = elemento;
                output.index = indexBuscado;
                break;
            }

            i++;
        }

        return output;
    };

    const borrarArchivos = (pathArchivo, index) => {
        const respuesta = buscarArchivo(index, props.prestaciones);

        if (respuesta.archivo.hasOwnProperty("id")) {
            // baja logica
            const _archivos = props.prestaciones.map((elemento) => {
                // if (elemento.id === respuesta.archivo.id) {
                if (!!elemento.id) {
                    elemento.bajaLogica = true; //se da de baja el ultimo con id y el original en caso que exista
                }
                return elemento;
            });

            props.actualizarPrestacionesFiles(_archivos);
        } else {
            // eliminacion fisica
            props.eliminarArchivo(
                pathArchivo,
                respuesta.index,
                props.actualizarPrestacionesFiles,
                props.prestaciones
            );
        }

        const mensajeConfig = {
            mostrarSnack: true,
            mensajeSnack:
                "Archivo borrado con éxito " + respuesta.archivo.nombreArchivo,
        };
        props.actualizarAtriutoSnackMensaje(mensajeConfig);
    };

    const dibujarArchivos = () => {
        let archivosCargados = null;
        if (props.prestaciones.length > 0) {
            const index = props.prestaciones.length - 1;
            const archivo = props.prestaciones[index];
            archivosCargados = (
                <ArchivosSubidos
                    fileInfos={[archivo]}
                    borrarArchivos={borrarArchivos}
                    deshabilitado={props.soloVista}
                />
            );
        } else {
            if (props.soloVista){
                archivosCargados = ( 
                <Typography
                    variant="caption"
                    color="primary"
                    align="center"
                    display="block"
                    style={{ fontWeight: "400" }}
                >
                    No hay archivos cargados en esta sección
                </Typography>)
            }
            else
                return null;
        }
        return (
            <Container disableGutters={true} className={classes.filaInputs}>
                {archivosCargados}
            </Container>
        );
    };

    useEffect(() => {
        const ventanaConfig = {
            estaVisible: props.erroresArchivos.length > 0,
            titulo: "Errores al cargar archivo de prestaciones",
            contenido: construirMensajeModal(),
            clickAceptar: onClickModalButton,
            textoBtnAceptar: textoLabel,
        };
        props.actualizarAtriutoVentanaDialogo(ventanaConfig);
    }, [textoLabel, props.erroresArchivos]);

    if (
        !props.prestadorSeleccionado ||
        props.tipoPresentacionSeleccionada === "" ||
        props.tipoComprobanteSeleccionado === 3
    ) {
        return null;
    }

    return (
        <Container disableGutters={true} className={classes.container}>
            <Container
                disableGutters={true}
                className={classes.containerTitulo}
            >
                <Typography className={classes.tituloSeccion}>
                    Soporte de prestaciones{" "}
                    {props.requeridos.prestaciones.requerido ? "*" : ""}
                </Typography>
                <Tooltip
                    placement="right"
                    title={
                        <>
                            <strong>EXTENSION PERMITIDA EXCEL O TXT EDI</strong>
                            <br />
                            Opción de descargar TEMPLATE GALENO
                            <br />
                            Solo permitimos 1 adjunto
                            <br />
                            Requerido
                            <br />
                            <span className={classes.importantText}>
                                IMPORTANTE:
                            </span>{" "}
                            LOS QUE PRESENTEN EXCEL, A PARTIR DEL 01/03/2021
                            SOLO SE ACEPTARA EXCEL TEMPLATE GALENO SIN EXCEPCION
                        </>
                    }
                >
                    <Typography className={classes.ayuda}>?</Typography>
                </Tooltip>
            </Container>
            <Container disableGutters={true} className={classes.filaInputs}>
                {mostrarBtnImportar()}
                {mostrarBtnDescargar()}
            </Container>
            {dibujarArchivos()}
        </Container>
    );
};

const mapStateToProps = (state) => ({
    pathTemporal: state.nuevaPresentacionReducer.pathTemporal,
    soloVista: state.nuevaPresentacionReducer.soloVista,
    prestadorSeleccionado: state.nuevaPresentacionReducer.prestadorSeleccionado,
    tipoPresentacionSeleccionada:
        state.nuevaPresentacionReducer.tipoPresentacionSeleccionada,
    prestaciones: state.nuevaPresentacionReducer.prestaciones,
    requeridos: state.nuevaPresentacionReducer.requeridos,
    erroresArchivos: state.adjuntarArchivoReducer.erroresArchivos,
    tipoComprobanteSeleccionado:
        state.nuevaPresentacionReducer.tipoComprobantesSeleccionado,
});

const actionCreators = {
    archivosSeleccionados: actionsAdjuntos.archivosSeleccionados,
    eliminarArchivo: actionsAdjuntos.eliminarArchivo,
    actualizarPrestacionesFiles:
        actionsPresentacion.actualizarPrestacionesFiles,
    actualizarAtriutoArchivos: actionsAdjuntos.actualizarAtriutoArchivos,
    actualizarAtriutoVentanaDialogo:
        actionsVentanaDialogo.actualizarAtriutoVentanaDialogo,
    actualizarAtriutoSnackMensaje:
        actionsSnackMensaje.actualizarAtriutoSnackMensaje,
};

export default connect(mapStateToProps, actionCreators)(Prestaciones);
